import { render, staticRenderFns } from "./AssignTeachers.vue?vue&type=template&id=5cc5e5f6&"
import script from "./AssignTeachers.vue?vue&type=script&lang=js&"
export * from "./AssignTeachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports